import { InMemoryCache } from '@apollo/client';

import { StrictTypedTypePolicies } from './apollo-helpers';
import { DistinctCarKey } from './generated';

const typePolicies: StrictTypedTypePolicies = {
  Query: {
    fields: {},
  },
};

export const cache: InMemoryCache = new InMemoryCache({
  typePolicies,
  addTypename: false,
});
